import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import toastr from '../toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TimePicker from '../../component/timePicker.vue'
import DatePicker from '../../component/dccore-form/datePicker.vue'
import { ROUTE_DEFAULT_COUNTRY } from '../../const/common'

if ($('#route_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#route_form',
    components: {
      RingLoader,
      TextInput,
      Multiselect,
      Singleselect,
      TimePicker,
      DatePicker
    },
    mixins: [mixins],
    data: {
      routeId : null,
      loading: 0,
      form: {
        entity: {
          drivers: [],
          isActive: true,
          countryId: null,
        },
        options: {
          errors: {},
          regions: [],
          deliveryTypes: [],
          addressTypes: [],
          countries: [],
        }
      },
    },
    mounted: function () {
      this.init().then(() => {
        if (!this.routeId) {
          this.form.entity.countryId = this.getDefaultCountryId()
        }
      })
    },
    methods: {
      createRoute: function (redirect) {

        let url = Routing.generate('api_post_route')
        Vue.http.post(url, {
          'data': this.form.entity,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('route_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateRoute: function (redirect) {
        let url = Routing.generate('api_patch_route', { id: this.routeId })

        Vue.http.patch(url, {
          'data': this.form.entity,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('route_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('form.updated'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      async init() {
        this.loading++
        this.form.options.deliveryTypes = await this.getDeliveryTypes()
        this.form.options.addressTypes = await this.getAddressTypes()
        this.form.options.regions = await this.getRegions()
        this.form.options.countries = await this.getCountries()

        if ($('#entity_id').length) {
          this.routeId = $('#entity_id').val()
          this.form.entity = await this.getRoute()
        }

        this.loading--
      },
      getRoute: function () {
        let url = Routing.generate('api_get_route', { id: this.routeId,
          context: 'edit' })

        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      getAddressTypes: function() {
        let url = Routing.generate('api_get_tags', { 'type': 'address_type',
          context: 'dropdown',
          exclude: ['NO_DELIVERY'] })

        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      getDeliveryTypes: function() {
        let url = Routing.generate('api_get_tags', { 'type' : 'delivery_type' })

        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      getRegions: function() {
        let url = Routing.generate('api_get_regions', { context: 'dropdown' })

        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      getCountries: function() {
        let url = Routing.generate('api_get_tags', { 'type' : 'route_country' })

        return this.$http.get(url).then(response => {
          return response.data
        })
      },
      addDriver() {
        this.form.entity.drivers.push(this.getEmptyDriver())
        this.refresh()
      },
      removeDriver(index) {
        this.form.entity.drivers.splice(index, 1)
        this.refresh()
      },
      getEmptyDriver() {
        return {
          'fullName' : null,
          'phone'    : null,
          'email'    : null,
        }
      },
      getDefaultCountryId() {
        let defaultCountry = this.form.options.countries.find((item) => {
          return item.systemValue === ROUTE_DEFAULT_COUNTRY
        })
        return defaultCountry.id
      },
    },

  })
}
